import {
  getStaffFilterDefaultValues,
  TStaffFilterValues,
} from "~/shared/hooks/useStaffFilterData/config";

export type TStaffFilter = TStaffFilterValues;

type metric = {
  category: number;
  posts: number;
  plannedSalesNextYear: number;
  forecastServiceVisits: number;
};

export type TDealerMetric = {
  rightNow: metric;
  future: metric;
};

export const getDefaultValues = (isRu: boolean): TStaffFilter =>
  getStaffFilterDefaultValues(isRu);
